import React from "react";
import OrderTable from "../Table";

const PrescriptionRequested = () => {
  return <OrderTable type="Prescription Requested" />;
};

export default PrescriptionRequested;
